<template>
  <div>
    <vk-grid
      v-if="detailData.results"
      style="border-top:1px solid #f1f1f1;    box-shadow: inset 4px 3px 11px rgba(0,0,0,.03);
   "
    >
      <div class="uk-width-expand" style="margin-top:15px;">
        <h2>
          {{ detailData.results.person_first_name }}
          {{ detailData.results.person_last_name }}
        </h2>
        <vk-tabs-vertical align="left">
          <vk-tabs-item title="Customer Info">
            <vk-grid>
              <div class="uk-width-2-3">
                <vk-button
                  type="primary"
                  size="small"
                  @click="fieldEdit = !fieldEdit"
                  >Düzenle</vk-button
                >
              </div>
              <div class="uk-width-1-3"></div>
            </vk-grid>
          </vk-tabs-item>
          <vk-tabs-item :title="tab.name" :key="tab.name" v-for="tab in tabs">
            <draggable v-model="pageItems" draggable=".drag">
              <li
                class="drag detailItem"
                v-if="item.location === tab.id"
                :key="item.location"
                v-for="item in pageItems"
              >
                <ListItem
                  :item="item"
                  :info="detailData.results[item.key]"
                  :preferences="detailData.preferences"
                  :edit="fieldEdit"
                />
              </li>
            </draggable>
          </vk-tabs-item>
          <vk-tabs-item title="Chat Details">
            <vk-card>
              <form action="javascript:void(0)" @submit="tabAdd()">
                <input
                  type="text"
                  placeholder="name"
                  class="uk-input"
                  v-model="tabDetail.name"
                />
                <input
                  type="text"
                  placeholder="id"
                  class="uk-input"
                  v-model="tabDetail.id"
                />
                <vk-button @click="tabAdd()" type="primary">Tab add</vk-button>
              </form>
            </vk-card>
            <vk-card>
              <form action="javascript:void(0)" @submit="itemAdd(detailItem)">
                <select v-model="detailItem.location" class="uk-select">
                  <option :value="tab.id" :key="tab.id" v-for="tab in tabs">{{
                    tab.name
                  }}</option>
                </select>
                <select v-model="detailItem.key" class="uk-select">
                  <option
                    :value="field"
                    :key="field"
                    v-for="field in detailData.all_fields"
                    >{{ field }}</option
                  >
                </select>
                <input
                  type="text"
                  name="ukinput"
                  class="uk-input"
                  v-model="detailItem.name"
                />
                <vk-button @click="itemAdd(detailItem)" type="primary"
                  >Send</vk-button
                >
              </form>
            </vk-card>
          </vk-tabs-item>
        </vk-tabs-vertical>
      </div>
      <div class="uk-width-1-3">
        <Notes table="crm_notes" field="leadId" :id="id" />
      </div>
    </vk-grid>
  </div>
</template>
<script>
import Modal from "./Modal.vue";
import Notes from "./Notes.vue";
import draggable from "vuedraggable";
import ListItem from "./ListItem";
import qs from "qs";
export default {
  name: "page",
  props: {
    table: String,
    id: String
  },
  components: {
    draggable,
    Notes,
    Modal,
    ListItem
  },
  data() {
    return {
      loading: false,
      fieldEdit: false,
      tabs: [
        { name: "Adtracks", id: "1", template: "tema içerik" },
        { name: "Deposits", id: "2", template: "para yatırma içerik" }
      ],
      detailItem: {},
      detailData: [],
      tabDetail: {},
      pageItems: []
    };
  },
  created() {
    this.getItems();
    this.getData();
  },
  watch: {
    pageItems(data) {
      localStorage.setItem(
        this.table + "_pagedetail_items",
        JSON.stringify(data)
      );
    }
  },
  methods: {
    tabAdd() {
      this.tabs.push(this.tabDetail);
      this.tabDetail = {};
    },
    onUpdate() {},
    getItems() {
      let varsa = localStorage.getItem(this.table + "_pagedetail_items");
      if (varsa) {
        this.pageItems = JSON.parse(varsa);
      }
    },
    itemAdd(e) {
      this.pageItems.push(e);
      this.detailItem = {};
    },
    getData() {
      this.loading = true;
      this.$axios
        .post(
          this.$root.config.endpoint + "/row/" + this.table + "/" + this.id,
          qs.stringify({
            table: this.table,
            id: this.id
          })
        )
        .then(response => {
          this.detailData = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
